var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIc33Desc2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 133,
    viewBox: "0 0 107 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_26)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.26122,
    y: 0.261217,
    width: 90.2026,
    height: 117.602,
    rx: 1.82852,
    fill: "#F3F3F3",
    stroke: "#EDEDED",
    strokeWidth: 0.522433
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.6744,
    y: 62.7756,
    width: 57.3762,
    height: 3.82508,
    rx: 1.91254,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.6744,
    y: 74.4375,
    width: 57.3762,
    height: 3.82508,
    rx: 1.91254,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.6744,
    y: 86.0991,
    width: 57.3762,
    height: 3.82508,
    rx: 1.91254,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.6744,
    y: 97.7607,
    width: 40.8009,
    height: 3.82508,
    rx: 1.91254,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4807 11.0722L53.4497 6.30298L42.2471 11.0722V16.6024C42.2471 19.7988 41.972 23.1474 45.8096 28.221C47.8357 30.8997 51.7472 32.5167 53.4497 32.9902C54.7374 32.8211 58.0338 31.6305 60.9182 28.221C64.4807 24.0099 64.495 19.0547 64.4807 16.6024V11.0722Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6675 20.141L51.6328 23.6005L58.0575 15.6931",
    stroke: "white",
    strokeWidth: 1.04487,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9636,
    y: 40.2148,
    width: 48.7978,
    height: 15.3365,
    fill: "url(#pattern0_5_26)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_26",
    x: 0.68438,
    y: 0,
    width: 105.631,
    height: 132.756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.31562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.65781
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_26",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5_26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5_26",
    transform: "matrix(0.00357143 0 0 0.0113636 -0.0017857 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5_26",
    width: 281,
    height: 88,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARkAAABYCAYAAADBY4NqAAAACXBIWXMAAAsSAAALEgHS3X78AAAFgklEQVR4nO3d8XHbNhTHcbye/482qDeoN4gyQZsNvEG8QewJ6hGcDbJB5A2kDegNrAmQgwOoKENKtIRHgMD3c+ezzpfYpEj9AILggxhjbowxjyatJ2vt03t/o4jMvi0i8ujfg2SstevE+1CMhO/X6HFJeR7UfCw0aHwerowxK2PMx8Tbuznz/+XYlhuFvzmZiKxSH9TEttba1+hXpnq/jh0XjfPgqAUch0t01tpu4v9P/nm4SrorOIc7qD8Kfuc+XdBoLEnpx+ESD8aY+1x//I9cfxhAGwgZAKoIGQCqigmZygfegGbNMvArIuE24rX/csLPXLB84BQE6qQVMrcicmuM+ZPzBmibVsgQLgDeMPALQBUhA0BVUzN+owHoeNCZO1qAohZC5k5EvhawHUCTWrhc4vY4kBFjMgBUETIAVBEyAFRRT6YeL644kcLevE74N8AoQqYerpxltsJEFXBh+lzAbrgHhf8qYDuSIWSAX7WAt9H8qWz8XK6qKvQxJgNAVSk9mTCeUF1XEWiddsjsXbV7/3rrr3tf45/FlfBr7CoCrdMKmQcGIQEYxmQAaCNkAKjiFjaKERWTp/xGRQgZ5LIWkbAy5TUlW+s1e8gMrFwQL4VCC9aObOuPY15aIeNaqftoBiUtFdAorZD5SEsFDOstZBi/vq6xN8+YDJCAiMQLF9748Oi/brLhbSFkwiMLYcZxF76stZ0ffKTXhd9E44cmuvTv90J4DOaEFkKGEgg4SURccDyybHJ6XC4Bv6zo0epgxi8AVYQMAFWEDABVhAwAVYQMAFXcXUpHa0kSYNEImdOGSoiGCX2uyv3mgt8NVK/2kHme0LvYTqk/DOA8Sw2Z+NIk9CQOQeHX0JnEWns39d/2HmwLz6T0f/bBWivJ9hRYuBJDJqzi91vvQvPSZKDOjaFUBXC5OUNmN3BJEkLj7WHFHMeTByQBXSlCZj8UGgyMArM4tbZZtgY8OBUy4dKlGxoDYWAUCQw1Um6c60vjb27o+ZulN95XfqMfzh04nWJgvOMpd7oiu9EFAP35UmvIDDXcap+9Elz5D/tZ9VZ8DY6hOyyrE4Olm7knro1s65ri5VD0zTWoJVyy5HRyTMa3KuveLdtiqoH1yh6GHlOR24rmuHBpfkxyysCv++B+nWFb/mdkTkocKNwRAhYg1zyZG5G3+Wpjay9R/hCoRK6Q+ZcTCGgDpR4AqCJkAKgiZACoImQAqKJoFU6KZmyvoykEqIw/zqvUe0XIoB8i8XfmIlUgdxkTQqZy0aTG/ndDiCzbUmogETL1cBMc73thwiMVC1RbATVCph5/+y8UqtXqiy2FzFhtnEdafCi5FZHb1ku31hAyQ2U9D0uXnHrEXkQovAUtzdeFNoWHzNCKBKEXUmVxH6BGuUJmF/U8ZluRIOiVkUg+LwDAf3KFzF3qMIkG1Uw0mBa/5m4LkEGxl0tRuUwT3ZIdek3tGaBguULmn5HbeSyiBlQmV8i0vtwF0AyewgagipABoIqQAaCKkAGgipABoIqQAaCKUg9AW/bRg8Rh1v3hgWK/dnfSYmaEDMb0ny8LD6dSGqNsoaRJ/7hNeqjYr+yaFCHTpqHW7NCqWWtHy19QGiOrseAvuioBIVOnl+gE7OITkxIZxdr1g2POygSaCJll6neJD9+P9UKQzUs/7GsJkCkImfLsh8LDLP+E3Pn92PowrOXD1Q8QM/XSsxWETH7uxPw0pVTogpQQKLvoQ3+uo3diKjpeKYXQ3YTjT8hk5ls6eiiXeY62oTtzG9wH4zMB8i4v0fu+Geu5TQmZ6q8Z8S5uHsX3TIGyj07ozm9DkoFsHyoEy7jQmHTHAmWIWGvL2AXA8wXNvsctpD+pCQFlIuLeb1d5Mk3v1BjzE/u0+WeYjh40AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc33Desc2);
export default __webpack_public_path__ + "static/media/Ic3.3Desc2.358aa16c49934642f317644d0cc20141.svg";
export { ForwardRef as ReactComponent };